// extracted by mini-css-extract-plugin
export default {"up_coming":"WeatherUpComing_up_coming__7Q9iG","up_coming_item1":"WeatherUpComing_up_coming_item1__CSKiY"};